import React, { useState, useEffect } from 'react'; 
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaUserCircle, FaEnvelope, FaQuestionCircle } from 'react-icons/fa'; 
import { getCurrentUser } from 'aws-amplify/auth';
import './Header.css';
import logo from '../assets/images/logo.png'; 
// INYECCIÓN QUIRÚRGICA: Importación del componente de notificaciones
import NotificationBell from '../components/NotificationBell';

const Header = ({ onLoginClick, onSignupClick }) => { 
    const [isMenuOpen, setIsMenuOpen] = useState(false); 
    const [user, setUser] = useState(null);
    const location = useLocation();

    useEffect(() => {
        checkUser();
        window.scrollTo(0, 0); // Asegura que al cambiar de página suba al inicio
    }, [location]);

    const checkUser = async () => {
        try {
            const currentUser = await getCurrentUser();
            setUser(currentUser);
        } catch {
            setUser(null);
        }
    };

    const closeMenu = () => setIsMenuOpen(false);

    // Extraemos el email para la campanita
    const userEmail = user?.signInDetails?.loginId || user?.attributes?.email;

    return (
        <header className="main-header">
            <div className="header-content">
                <Link to="/" className="logo" onClick={closeMenu}>
                    <img src={logo} alt="Logo" />
                    <span className="logo-text">Giovanni Scarvaci & Asociados</span>
                </Link>

                <button className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                </button>

                <nav className={`main-nav ${isMenuOpen ? 'open' : ''}`}>
                    <ul>
                        <li><Link to="/" onClick={closeMenu}>Inicio</Link></li> 
                        <li><Link to="/servicios" onClick={closeMenu}>Servicios</Link></li>
                        <li><Link to="/libros" onClick={closeMenu}>Libros</Link></li>
                        <li><Link to="/cursos" onClick={closeMenu}>Cursos</Link></li>
                        
                        {/* ENLACE DE CONTACTO */}
                        <li>
                            <Link to="/contacto" onClick={closeMenu} className={location.pathname === '/contacto' ? 'active-link' : ''}>
                                Contactos
                            </Link>
                        </li>

                        {/* --- NUEVO BOTÓN DE AYUDA PARA ADULTOS MAYORES --- */}
                        <li>
                            <Link to="/ayuda" onClick={closeMenu} style={{ color: '#C5A059', fontWeight: 'bold' }}>
                                <FaQuestionCircle style={{ marginRight: '5px' }} /> Ayuda
                            </Link>
                        </li>
                        
                        <li className="nav-divider"></li>

                        {/* INYECCIÓN QUIRÚRGICA: Campanita de notificaciones en tiempo real */}
                        {user && (
                            <li className="notification-item-header">
                                <NotificationBell userEmail={userEmail} />
                            </li>
                        )}

                        {user ? (
                            <li>
                                <Link to="/profile" className="profile-link" onClick={closeMenu}>
                                    <FaUserCircle /> Mi Panel
                                </Link>
                            </li>
                        ) : (
                            <li className="auth-buttons">
                                <button className="login-link-btn" onClick={() => { onLoginClick(); closeMenu(); }}>
                                    Iniciar Sesión / Registro
                                </button>
                            </li>
                        )}
                        
                        <li>
                            <Link to="/consultas" className="primary-cta" onClick={closeMenu}>
                                <FaEnvelope /> Agendar Cita
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;